import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from './Topbar';
import Sidebar from './Sidebar';

export function AppShell() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Skip to content link for accessibility */}
      <a
        href="#main-content"
        className="skip-to-content"
        data-testid="skip-to-content-link"
      >
        Skip to content
      </a>
      
      {/* Topbar */}
      <header
        className="h-16 border-b sticky top-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
        data-testid="topbar"
      >
        <Topbar />
      </header>
      
      {/* Main layout */}
      <div className="flex">
        {/* Sidebar */}
        <aside
          className="hidden lg:block w-[272px] border-r min-h-[calc(100vh-4rem)] sticky top-16 bg-card"
          data-testid="sidebar"
        >
          <Sidebar />
        </aside>
        
        {/* Main content */}
        <main
          id="main-content"
          className="flex-1 p-6 lg:p-8"
          data-testid="main-content"
        >
          <div className="mx-auto max-w-[1400px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default AppShell;
